<template lang="pug">
div
  template(v-if="socialList.length > 0")
    template(v-for="(item, key, index) in socialList")
      a(v-if="item.social_link!==null && item.social_platform !='livechat'" :href="item.social_link" target="_blank")
        img(v-if="item.social_platform !='trustpilot' && item.social_platform !='joylink'" :src="'/new/img/follow/'+item.social_platform+'.webp'")
        img(v-if="item.social_platform =='joylink'" :src="'/new/img/follow/link.webp'")
      //- a(v-if="item.social_link !='' && item.social_link !=null" && item.social_platform !='livechat'" :href="item.social_link" target="_blank")
        img(:src="'/images/follow/'+item.social_platform+'.png'")
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
export default {
  data(){
    return{
      contactList: {},
      feedback: {
        status: "",
        success: ""
      },
    }
  },
  computed:{
		socialList(){
      if(this.$store.getters.getSocialList.length > 0){
        return this.$store.getters.getSocialList
      }else{
        return []
      }
			
		}
	},
  created(){
  },
  mounted(){
  },
  methods:{
  }
}
</script>